<div class="p-inputgroup">
    <p-inputNumber #inputNumber [formControl]="formControl" mode="decimal" [showButtons]="true"
        [inputStyle]="{width: '100%', borderTopLeftRadius: '5px', borderBottomLeftRadius: '5px'}"
        [formlyAttributes]="field" [minFractionDigits]="0"></p-inputNumber>
</div>